<template>
  <section id="podcast" class="bg-white pt-[70px]">
    <div class="bg-black">
      <ClientOnly>
        <div class="container relative py-10 lg:py-[70px] gallery md:px-20">
          <h1
            class="text-xl lg:text-[28px] text-white font-OPPO-sans-medium text-center uppercase break-words px-4 pb-6"
            v-text="$t('common.podcasts_and_reviews')"
          />
          <swiper-container
            ref="swiperRef"
            :init="false"
            slides-per-view="1"
            space-between="10"
            :navigation="false"
            :pagination="false"
          >
            <swiper-slide
              v-for="(video, key) in podcastStore.productVideos"
              :key="key"
              :class="video.youtube_details ? 'block' : 'hidden'"
              class="max-w-[266px] md:max-w-full"
            >
              <ProductPodcastVideo
                :video="video"
                @play="(p) => (playItem = p)"
                v-if="video && video.youtube_details"
              />
            </swiper-slide>
          </swiper-container>
          <button
            class="absolute left-1.5 button-previous top-1/2 disabled:opacity-60 md:block hidden"
            @click="goPrevious"
            :disabled="!isPrevious"
          >
            <img src="/Button - Previous.png" class="w-[60px] h-[60px]" />
          </button>
          <button
            class="absolute right-1.5 button-next top-1/2 disabled:opacity-60 md:block hidden"
            @click="goNext"
            :disabled="!isNext"
          >
            <img src="/Button - Next.png" class="w-[60px] h-[60px]" />
          </button>
        </div>
        <PodcastsVideoPlay
          class="transition-all duration-75"
          :video="playItem"
          v-if="playItem"
          @close="playItem = null"
        />
      </ClientOnly>
    </div>
  </section>
</template>

<script setup>
import { useMainStore } from "~/store";
import { usePodcastStore } from "~/store/podcast";

const store = useMainStore();
const nuxtApp = useNuxtApp();
const podcastStore = usePodcastStore();

const playItem = ref(null);
const swiperRef = ref(null);
const isNext = ref(true);
const isPrevious = ref(true);

const scrollPosition = ref(0);
const defaultDate = ref({
  start: "",
  end: "",
});

const videos = ref(podcastStore.productVideos);

onBeforeMount(() => {
  if (nuxtApp.$initXyzAnim) {
    nuxtApp.$initXyzAnim();
  }
  if (nuxtApp.$initSwiper) {
    nuxtApp.$initSwiper();
  }
  // podcastStore.fetchPodacasts(false);
});

onMounted(() => {
  if (!import.meta.client) return false;
  setTimeout(() => {
    const params = {
      autoplay: true,
      injectStyles: [],
      breakpoints: {
        120: {
          freeMode: true,
          slidesPerView: 0,
        },
        640: {
          freeMode: false,
          slidesPerView: 2,
        },
        768: {
          freeMode: false,
          slidesPerView: 3,
        },
        1024: {
          freeMode: false,
          slidesPerView: 3,
        },
        1280: {
          freeMode: false,
          slidesPerView: 4,
        },
      },
      on: {
        slideChange: function () {
          if (swiperRef.value.swiper.isEnd) {
            isNext.value = false;
          } else {
            isNext.value = true;
          }

          if (swiperRef.value.swiper.activeIndex == 0) {
            isPrevious.value = false;
          } else {
            isPrevious.value = true;
          }
        },
      },
    };

    Object.assign(swiperRef.value, params);

    swiperRef.value.initialize();

    if (swiperRef.value.swiper.isEnd) {
      isNext.value = false;
    } else {
      isNext.value = true;
    }

    if (swiperRef.value.swiper.activeIndex == 0) {
      isPrevious.value = false;
    } else {
      isPrevious.value = true;
    }
  }, 500);
});

function goNext(e) {
  isNext.value = swiperRef.value.swiper.slideNext();
  if (swiperRef.value.swiper.isEnd) {
    isNext.value = false;
  }
  isPrevious.value = true;
}
function goPrevious(e) {
  swiperRef.value.swiper.slidePrev();
  if (swiperRef.value.swiper.activeIndex == 1) {
    isPrevious.value = false;
  }
  isNext.value = true;
}
</script>
<style lang="postcss">
swiper-container::part(button-prev),
swiper-container::part(button-next) {
  @apply bg-[#9798ac] bg-opacity-25 rounded-full items-center flex justify-center w-[60px] h-[60px];
}
</style>
